import { CwtApiSchema, CwtModel, CwtProp } from "@cawita/core-front/api";

@CwtModel({ name: 'notification-check'})
export class NotificationCheck extends CwtApiSchema {
    @CwtProp() ip: string;
    @CwtProp() browser: string;
    @CwtProp() creationDate: Date;
}